import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import { Button, Form, Container, Row, Col, Table } from 'react-bootstrap';
import { ImageModule } from "../../common/Image_Module";
import { AltSiteName,OfficeBaseURL } from "../../utils";
import ScrollAnimation from 'react-animate-on-scroll';
import './SalesLocation.scss'
import OfficeLandingMap from "../../office-landing-map";
import ContactModule from "../../CarrierLanding/Connect/ContactModule";
import NoImage from "../../../images/no-image.png";
// markup
const OfficeListing = (props) => {
    return (
        <React.Fragment>
            <div className="office-listing-wrap">
            <div className="sales-location office-listing">
                    <Container>
                        <Row>
                                {props.GQLOffices && props.GQLOffices.map((item)=>{
                                    let exclude_offices = item.show_details;
                                    let img = item.Tile_Image?.url ? (<ImageModule ImageSrc={item.Tile_Image} ggfx_results={item.ggfx_results} altText={item.Tile_Image.alternativeText ? item.Tile_Image.alternativeText : item.Name} strapi_id={item.id} imagename={"our-offices.Tile_Image.commontile"} />) : (<img src={NoImage} alt={item.Meta_Title ?? "no-image"} loading={"lazy"} />);
                                    return<>
                                    <Col md={6} lg={3} className="office-item">
                                    <div className="location-info">
                                    <div className="location-img img-zoom">
                                    {exclude_offices ? (<Link to={`${OfficeBaseURL}${item.URL}/`}>{img}</Link>) : (img)}
                                    </div>
                                    <div className="location-details">
                                        <h2>{exclude_offices ? (<Link to={`${OfficeBaseURL}${item.URL}/`}>{item.Name}</Link>) : (item.Name)}</h2>
                                        <address>{item.Office_Address}</address>
                                        {item.Sales_Phone_Number?
                                        <div className="sales-contact">
                                            Sales
                                            <a href={`tel:${item.Sales_Phone_Number}`} className="tel">
                                                {item.Sales_Phone_Number}
                                            </a>
                                        </div>
                                        :""}
                                        {item.Lettings_Phone_Number?
                                        <div className="sales-contact">
                                            Lettings
                                            <a href={`tel:${item.Lettings_Phone_Number}`} className="tel">
                                            {item.Lettings_Phone_Number}   
                                            </a>
                                        </div>
                                        :""}
                                        {(!(item?.Sales_Phone_Number || !item?.Lettings_Phone_Number)) &&
                                            <div className="no sales-contact"><span></span></div>
                                        }
                                    </div>
                                </div>
                                </Col>
                                    </>
                                })}
                            
                        </Row>
                    </Container>
                
            </div>
        <OfficeLandingMap GQLOffices={props.GQLOffices}/>
        <ContactModule style={`d-none`}/>
        </div>
        </React.Fragment >
    )
}
export default OfficeListing